export default __webpack_public_path__ + "static/media/CRs.e9f40654.svg";